<template>
  <div class="course">
    <div class="nuv">
      <a class="active" href="/tjkStudy/courseList">培训课程</a>&gt;
      <a class="active"  :href="'/tjkStudy/courseDetail/' + test.courseId ">{{courseName}}</a>&gt;
      <span>{{test.catalogName}}</span>
    </div>
    <div class="video">
      <div class="left">
        <h2>{{test.catalogName}}</h2>
        <component1  :poster="poster" id="component"></component1>
        <div id="pdf_viewer"></div>
      </div>
      <div class="right">
        <div class="catalog" >课程目录</div>
        <ul>
          <li :class="{'bg':(key+1)%2}" v-for=" (lists,key) in List" @click="MaterialDetail(lists.materialId)">
            <p>{{key+1}}、{{lists.catalogName}}</p>
            <span><template v-if="lists.duration != null">({{formatSeconds(lists.duration)}})</template> <img :src="img[0].src" class="resType"></span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  import component1 from './video.vue'
  import PDFObject from '../assets/js/pdfobject.min'
  import play from './../assets/images/play.png'
  import pdf from './../assets/images/pdf.png'
  export default {
    data() {
      return {
        "materialId": '',
        "courseId": '',
        "courseName":'',
        "List": '',
        "test": '',
        "poster": '',
        "id":this.$route.params.id,
        "ids":this.$route.params.ids,
        "img": [
          {src: play},
          {src: pdf}
        ]
      }
    },
    mounted: function () {
      this.MaterialDetail()
      this.MaterialList()
      this.$nextTick(function(){
        this.MaterialList()
      })
    },
    components: {
      component1,
    },
    methods: {
      GetArgsFromHref: function (sArgName) {
          var sHref = window.location.href;
          var args = sHref.split("?");
          var retval = "";
          if (args[0] == sHref) /*参数为空*/
          {
              return retval;
              /*无需做任何处理*/
          }
          var str = args[1];
          args = str.split("&");
          for (var i = 0; i < args.length; i++) {
              str = args[i];
              var arg = str.split("=");
              if (arg.length <= 1) continue;
              if (arg[0] == sArgName) retval = arg[1];
          }
          return retval;
      },//获取参数
      MaterialDetail: function (materialId) {
        var courseName=decodeURI(this.GetArgsFromHref("courseName"))
        this.courseName=decodeURI(courseName)
        this.materialId=materialId
        var data={
          "materialId":materialId?this.materialId:this.GetArgsFromHref("materialId")
        };
        this.$http.post(API_ROOT.system+'/course/study/queryMaterialDetail',data).then(response => {
          var result=response.data;
          if(result.success){
            this.test=result.data 
            this.poster=this.test.resourceUrl
            $("#component").hide()
            $("#pdf_viewer").hide()
            if(this.test.resourceType=='mp4'){
              $("#component").show()
              $("#pdf_viewer").hide()
            }else {
              $("#component").hide()
              $("#pdf_viewer").show()

              var options = {
                pdfOpenParams: {
                  navpanes: 0,
                  toolbar: 0,
                  statusbar: 0,
                  view: "FitV",
                  pagemode: "thumbs",
                  page: 1
                },
                forcePDFJS: true,
                PDFJS_URL: "http://cmain.static.itaojin.cn/static/main/scripts/vendor/PDFjs/generic/web/viewer.html"
              };
              if(PDFObject.supportsPDFs){
                PDFObject.embed(this.poster, "#pdf_viewer", options )
              } else {
                location.href = "/resume/canvas"
              }
            }
            var datas={
              "materialId":materialId?this.materialId:this.GetArgsFromHref("materialId"),
              "courseId":this.GetArgsFromHref("courseId")
            }
           
           
            this.$http.post(API_ROOT.system+'/course/study/completeStudyMaterial',datas).then(response=>{
              var result=response.data
              if(result.success){
               // this.queryUserMaterial()
              }else{
                alert(result.msg)
              }
            },response=>{
              alert("网络繁忙，请稍后重试！")
            })
          }else{
            alert(result.msg)
          }
        }, response => {
          alert("网络异常，稍后重试！")
        })
      },//课件详细信息
      // queryUserMaterial:function(){
      //   var data ={
      //     "courseId":this.GetArgsFromHref("courseId")
      //     };
      //   this.$http.post(API_ROOT.system+'/course/study/queryUserMaterial',data).then(response=>{
      //     var result= response.data
      //     if(result.success){
      //       if(result.data.length == this.List.length){
      //         this.$http.post(API_ROOT.system+'/course/study/completeStudyCourse',data).then(response=>{
      //           var result=response.data
      //           if(result.success){
      //           }else{
      //             alert(result.msg)
      //           }
      //         },response=>{
      //           alert("网络繁忙，请稍后重试！")
      //         })
      //       }
      //     }else{
      //       alert(result.msg)
      //     }
      //   },response=>{
      //     alert("网络繁忙，请稍后重试！")
      //   })
      // },//课程记录信息
      MaterialList:function(){
        this.courseId=this.GetArgsFromHref("courseId");
        var data={
          "courseId":this.GetArgsFromHref("courseId")
        };
        this.$http.post(API_ROOT.system+'/course/study/queryMaterialList',data).then(response=>{
          var result=response.data;
          if(result.success){
            for(var i=0;i<result.data.length;i++){
              if(result.data[i].resourceType=='mp4'){
                $(".resType").eq(i).attr('src',this.img[0].src)
              }else if(result.data[i].resourceType=='pdf'){
                $(".resType").eq(i).attr('src',this.img[1].src)
              }
            }
            this.List=result.data;
          }else{
            alert(result.msg)
          }
        },response=>{
          alert("网络异常，请稍后重试！")
        })
      },//课件信息列表
      formatSeconds(value) { 
        var result = ''
        var days = parseInt(value / ( 60 * 60 * 24));
        var hours = parseInt((value % ( 60 * 60 * 24)) / (60 * 60));
        if(hours > 0){
          hours = hours < 9 ? ('0'+hours):hours  
          result += hours + ':'
        }
        var minutes = parseInt((value % (60 * 60)) / (60));
        if(minutes > 0){
          minutes = minutes < 9 ? ('0'+minutes):minutes  
          result += minutes + ':'
        }
        var seconds = value % 60;
        if(seconds > 0){
          seconds = seconds < 9 ? ('0'+seconds):seconds  
          result += seconds 
        }
        return result
      } 
    }
  }
</script>



// WEBPACK FOOTER //
// ./src/page/course.vue